export default __webpack_public_path__ + "static/media/trophy.3b0b46c6.png";